import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import './Prose.css';

export interface ProseProps {
  children: ReactNode;
  className?: string;
}

/**
 * Long-form reading: policy, terms, a letter. Maps the type roles onto
 * ordinary headings, paragraphs and lists so a legal document can stay
 * semantic HTML without a Typography tag on every line.
 */
export function Prose({ children, className }: ProseProps) {
  return <div className={classes('prose', className)}>{children}</div>;
}
